export default __webpack_public_path__ + "static/media/feijao.a78f4939.svg";